<script setup lang="ts">
import useGlobalStore from '@/stores/modules/global';
const globalStore = useGlobalStore(); 
</script>

<template>
  <section v-if="globalStore.isUserLoggedIn" class="stagnant-section bg-off_white d-flex align-center">
    <slot />
  </section>
</template>
<style scoped lang="scss">

@use '@/styles/variables';

.stagnant-section:has(*) {
  position: sticky;
  top: 0;
  height: variables.$default-breadcrumbs-height;
  width: 100%;
  z-index: 1;
}
</style>
